<template>
  <ul class="main" :class="[ {main : mode == pc } ]">
    <li>
      <a href="#" @click.prevent="toSquare">
        <div>ひろば<span v-show = "itsNewSquareNo > 0" :class="[ {notification: mode == pc} ]">{{itsNewSquareNo}}</span></div>
      </a>
    </li>
    <li>
      <a href="#" @click.prevent="toCircle">
        <div>サークル<span v-show = "itsNewCircleNo > 0" :class="[ {notification: mode == pc} ]">{{itsNewCircleNo}}</span></div>
      </a>
    </li>
    <li v-if="Boolean(loginFlg)">
      <router-link :to = "{ name:'MyspaceTimeLine', params:{ accountId: account.id} }">
        マイスペース
        <span v-show = "itsNewMyspaceNo > 0" :class="[ {notification: mode == pc} ]">{{itsNewMyspaceNo}}</span>
      </router-link>
    </li>
  </ul>
</template>
<script setup>
import { computed, defineProps, ref, reactive } from "vue"
import { onMounted } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification';
import { useRouter } from 'vue-router'
import 'vue-toast-notification/dist/theme-sugar.css';
import _ from 'lodash'
import Global from '../../js/constant.js'
import axios from "axios";

// store取得
const $store = useStore();
const $toast = useToast();
const $router = useRouter();

// --- props ---
defineProps({
  mode: {
    type: Number,
    required: true
  },
})

// --- define state ---
const itsNewSquare = reactive([]);
const itsNewCircle = reactive([]);
const itsNewMyspace = reactive([]);
const itsNewSquareNo = ref(0);
const itsNewCircleNo = ref(0);
const itsNewMyspaceNo = ref(0);

// --- computed ---
const account = computed(() => $store.state.core.account);
const loginFlg = computed(() => $store.state.core.loginFlg);
const pc = computed(() => Global.device_division_id.pc);

// --- mounted ---
onMounted(() => {
  setInterval(getNews, Global.header_navi_interval)
});

// --- methods ---
const setCircleMode = (val) => $store.commit('setCircleMode', val);
const setCircleHashtagDivisionId = (val) => $store.commit('setCircleHashtagDivisionId', val);
const setCircleHashtagId = (val) => $store.commit('setCircleHashtagId', val);
const setHashtagDivisionId = (val) => $store.commit('setHashtagDivisionId', val);
const setHashtagId = (val) => $store.commit('setHashtagId', val);
const setHashtagIds = (val) => $store.commit('setHashtagIds', val);
const setClientErrors = (val) => $store.commit('setClientErrors', val);

const getNews = async () => {
  if (!loginFlg.value) return
  if (!account.value) return
  
  let params = {account_id : $store.state.core.account.id}
  await axios.post(Global.url.api_entries_its_new, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      itsNewSquareNo.value = res.data.its_news.square.length
      itsNewCircleNo.value = res.data.its_news.circle.length
      itsNewMyspaceNo.value = res.data.its_news.myspace.length

      if (_.difference(itsNewSquare, res.data.its_news.square).length > 0 ) {
        $toast.info("ひろばに新着メッセージがあります")
        itsNewSquare.value = res.data.its_news.square
      }
      if (_.difference(itsNewCircle, res.data.its_news.circle).length > 0 ) {
        $toast.info("サークルに新着メッセージがあります")
        itsNewCircle.value = res.data.its_news.circle
      }
      if (_.difference(itsNewMyspace, res.data.its_news.myspace).length > 0 ) {
        $toast.info("マイスペースに新着メッセージがあります")
        itsNewMyspace.value = res.data.its_news.myspace
      }
    }
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({
      func:"common/header/header-navigation.vue::getNews",
      params: {account_id : account.value.id},
      errorMessage:error
    })
  })
}
const toSquare = () => {
  setHashtagDivisionId(Global.hashtag_division_id.home)
  setHashtagId(null)
  setHashtagIds([])
  $router.push( { name : 'square' })
}
const toCircle = () => {
  setCircleMode(Global.circle_mode.public)
  setCircleHashtagDivisionId(Global.hashtag_division_id.home)
  setCircleHashtagId(null)
  $router.push({ name : 'circle-top'})
}
// const toMyspace = () => {
//   $router.push({ path : '/myspace/' + account.value.id }, () => {})
// }
</script>
<style scope>
.bage_item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>